import React from "react";
import ReportDelay from "../Components/ReportDelay/ReportDelay";

export default function ReportDelayTab() {
  return <ReportDelay />;
}
